import PortalQuoteQueryJets from "../../components/portal/PortalQuoteQueryJets";
import TripTypeTabs from "../../components/shared/TripTypeTabs";
import { useState } from "react";

const PortalHome = () => {
    const [tripType, setTripType] = useState("oneway");

    const modalComplete = () => {};

    return (
        <>
            <section className="home__query">
                <div className="home__query__content wrap">
                    <h1 className="portal__title">Welcome Aboard</h1>

                    {/* Trip Type Tabs - moved outside quote query for proper alignment */}
                    <TripTypeTabs
                        tripType={tripType}
                        onTripTypeChange={setTripType}
                        className="home__query__trip-type-tabs"
                    />

                    <PortalQuoteQueryJets
                        onModalSuccess={modalComplete}
                        tripType={tripType}
                        setTripType={setTripType}
                    />
                </div>
            </section>
        </>
    );
};

export default PortalHome;
